"use client";

import { useLocalePathname } from "@i18n/routing";

/**
 * Badge Marquee Component
 * Displays a scrolling marquee of partner/featured badges
 * Rendered below the footer by the marketing layout; only shows on the homepage
 */
export function BadgeMarquee() {
	const pathname = useLocalePathname();

	if (pathname !== "/") {
		return null;
	}

	return (
		// 2026-10-12 改回可见：display:none 藏外链违反 Google 垃圾政策（hidden links），
		// 改成 24px 高的小徽章跑马灯；目录站校验徽章外链要求挂在首页，所以别删
		<div className="border-black/[.08] border-t py-4 bg-gray-4 overflow-hidden">
			<div className="container">
				<div className="flex gap-8 items-center animate-scroll-left hover:[animation-play-state:paused] w-max py-2 opacity-70 grayscale hover:grayscale-0 transition-all duration-300">
					{[...Array(2)].map((_, i) => (
						// eslint-disable-next-line react/no-array-index-key
						<div key={i} className="flex gap-8 items-center">
							<a
								href="https://toolfame.com/item/imagesartai"
								target="_blank"
								rel="noopener noreferrer"
							>
								{/* eslint-disable-next-line @next/next/no-img-element */}
								<img
									src="https://toolfame.com/badge-light.svg"
									alt="Featured on toolfame.com"
									width="136"
									height="43"
									className="h-6 w-auto rounded-sm"
									loading="lazy"
								/>
							</a>
							<a
								href="https://twelve.tools"
								target="_blank"
								rel="noopener noreferrer"
							>
								{/* eslint-disable-next-line @next/next/no-img-element */}
								<img
									src="https://twelve.tools/badge0-white.svg"
									alt="Featured on Twelve Tools"
									width="160"
									height="43"
									className="h-6 w-auto rounded-sm"
									loading="lazy"
								/>
							</a>
							<a
								href="https://startupfa.me/s/imagesart-ai?utm_source=imagesart.ai"
								target="_blank"
								rel="noopener noreferrer"
							>
								{/* eslint-disable-next-line @next/next/no-img-element */}
								<img
									src="https://startupfa.me/badges/featured/light.webp"
									alt="Featured on Startup Fame"
									width="136"
									height="43"
									className="h-6 w-auto rounded-sm"
									loading="lazy"
								/>
							</a>
							<a
								href="https://toolpilot.ai"
								target="_blank"
								rel="noopener noreferrer"
							>
								{/* eslint-disable-next-line @next/next/no-img-element */}
								<img
									src="https://www.toolpilot.ai/cdn/shop/files/f-w_690x151_crop_center.png"
									alt="toolpilot.ai"
									width="136"
									height="43"
									className="h-6 w-auto rounded-sm"
									loading="lazy"
								/>
							</a>
							<a
								href="https://code.market?code.market=verified"
								target="_blank"
								rel="noopener noreferrer"
							>
								{/* eslint-disable-next-line @next/next/no-img-element */}
								<img
									src="https://code.market/assets/manage-product/featured-logo-bright.svg"
									alt="ai tools code.market"
									width="136"
									height="43"
									className="h-6 w-auto rounded-sm"
									loading="lazy"
								/>
							</a>
							<a
								href="https://dang.ai/"
								target="_blank"
								rel="noopener noreferrer"
							>
								{/* eslint-disable-next-line @next/next/no-img-element */}
								<img
									src="https://cdn.prod.website-files.com/63d8afd87da01fb58ea3fbcb/6487e2868c6c8f93b4828827_dang-badge.png"
									alt="Dang.ai"
									width="120"
									height="43"
									className="h-6 w-auto rounded-sm"
									loading="lazy"
								/>
							</a>
							<a
								href="https://www.startupinspire.com"
								target="_blank"
								rel="noopener noreferrer"
							>
								{/* eslint-disable-next-line @next/next/no-img-element */}
								<img
									src="https://www.startupinspire.com/images/badge_3.svg"
									alt="Featured on Startup Inspire"
									width="136"
									height="43"
									className="h-6 w-auto rounded-sm"
									loading="lazy"
								/>
							</a>
							<a
								href="https://dofollow.tools"
								target="_blank"
								rel="noopener noreferrer"
							>
								{/* eslint-disable-next-line @next/next/no-img-element */}
								<img
									src="https://dofollow.tools/badge/badge_light.svg"
									alt="Featured on Dofollow.Tools"
									width="160"
									height="43"
									className="h-6 w-auto rounded-sm"
									loading="lazy"
								/>
							</a>
							<a
								href="https://saasfame.com/item/imagesartai"
								target="_blank"
								rel="noopener noreferrer"
							>
								{/* eslint-disable-next-line @next/next/no-img-element */}
								<img
									src="https://saasfame.com/badge-light.svg"
									alt="Featured on saasfame.com"
									width="155"
									height="43"
									className="h-6 w-auto rounded-sm"
									loading="lazy"
								/>
							</a>
							<a
								href="https://findly.tools/imagesart-ai?utm_source=imagesart-ai"
								target="_blank"
								rel="noopener noreferrer"
							>
								{/* eslint-disable-next-line @next/next/no-img-element */}
								<img
									src="https://findly.tools/badges/findly-tools-badge-light.svg"
									alt="Featured on findly.tools"
									width="150"
									height="43"
									className="h-6 w-auto rounded-sm"
									loading="lazy"
								/>
							</a>
							<a
								href="https://poweruptools.com"
								target="_blank"
								rel="noopener noreferrer"
							>
								{/* eslint-disable-next-line @next/next/no-img-element */}
								<img
									src="https://poweruptools.com/assets/images/badge.png"
									alt="Power Up Tools"
									width="136"
									height="43"
									className="h-6 w-auto rounded-sm"
									loading="lazy"
								/>
							</a>
							<a
								href="https://auraplusplus.com/projects/imagesart"
								target="_blank"
								rel="noopener noreferrer"
							>
								{/* eslint-disable-next-line @next/next/no-img-element */}
								<img
									src="https://auraplusplus.com/images/badges/featured-on-light.svg"
									alt="Featured on Aura++"
									width="150"
									height="43"
									className="h-6 w-auto rounded-sm"
									loading="lazy"
								/>
							</a>
							<a
								href="https://launch-list.org/product/imagesart"
								target="_blank"
								rel="noopener noreferrer"
							>
								{/* eslint-disable-next-line @next/next/no-img-element */}
								<img
									src="https://launch-list.org/badges/svg/launch_list_badge_live.svg"
									alt="Launch List Badge"
									width="160"
									height="43"
									className="h-6 w-auto rounded-sm"
									loading="lazy"
								/>
							</a>
							<a
								href="https://postmake.io/submit"
								target="_blank"
								rel="noopener noreferrer"
							>
								{/* eslint-disable-next-line @next/next/no-img-element */}
								<img
									src="https://postmake.io/postmake_badge_light.png"
									alt="Featured on the Postmake directory"
									width="170"
									height="43"
									className="h-6 w-auto rounded-sm"
									loading="lazy"
								/>
							</a>
							<a
								href="https://deeplaunch.io"
								target="_blank"
								rel="noopener noreferrer"
							>
								{/* eslint-disable-next-line @next/next/no-img-element */}
								<img
									src="https://deeplaunch.io/badge/badge_light.svg"
									alt="Featured on DeepLaunch.io"
									width="200"
									height="54"
									className="h-6 w-auto rounded-sm"
									loading="lazy"
								/>
							</a>
							<a
								href="https://toolsaiapp.com/"
								target="_blank"
								rel="noopener noreferrer"
							>
								{/* eslint-disable-next-line @next/next/no-img-element */}
								<img
									src="https://toolsaiapp.com/wp-content/uploads/2025/12/badge.png"
									alt="Featured on Tools AI App"
									height="54"
									className="h-6 w-auto rounded-sm"
									loading="lazy"
								/>
							</a>
							{/* 徽章图 shinylaunch.com/static/images/badge.png 已 404，先用文字 */}
							<a
								href="https://shinylaunch.com"
								target="_blank"
								rel="noopener noreferrer"
								className="flex h-6 items-center whitespace-nowrap rounded-sm border border-slate-300 px-2 text-xs font-medium text-slate-700"
							>
								ShinyLaunch
							</a>
							{/* 姊妹站 facelessvideos.app 的工具页 */}
							<a
								href="https://facelessvideos.app/tiktok-audio-downloader"
								target="_blank"
								rel="noopener noreferrer"
								className="flex h-6 items-center gap-1.5 whitespace-nowrap rounded-sm border border-slate-300 px-2 text-xs font-medium text-slate-700"
							>
								{/* alt 留空：图标是装饰，锚文本只取后面的文字 */}
								{/* eslint-disable-next-line @next/next/no-img-element */}
								<img
									src="https://facelessvideos.app/icon.png"
									alt=""
									width="16"
									height="16"
									className="h-4 w-4"
									loading="lazy"
								/>
								TikTok Audio Downloader
							</a>
							<a
								href="https://facelessvideos.app/instagram-audio-downloader"
								target="_blank"
								rel="noopener noreferrer"
								className="flex h-6 items-center gap-1.5 whitespace-nowrap rounded-sm border border-slate-300 px-2 text-xs font-medium text-slate-700"
							>
								{/* alt 留空：图标是装饰，锚文本只取后面的文字 */}
								{/* eslint-disable-next-line @next/next/no-img-element */}
								<img
									src="https://facelessvideos.app/icon.png"
									alt=""
									width="16"
									height="16"
									className="h-4 w-4"
									loading="lazy"
								/>
								Instagram Audio Downloader
							</a>
							{/* 姊妹站 commentviewer.net / tikviewer.org 首页 */}
							<a
								href="https://commentviewer.net/"
								target="_blank"
								rel="noopener noreferrer"
								className="flex h-6 items-center gap-1.5 whitespace-nowrap rounded-sm border border-slate-300 px-2 text-xs font-medium text-slate-700"
							>
								{/* eslint-disable-next-line @next/next/no-img-element */}
								<img
									src="https://commentviewer.net/brand/favicon.svg"
									alt=""
									width="16"
									height="16"
									className="h-4 w-4"
									loading="lazy"
								/>
								Comment Viewer
							</a>
							<a
								href="https://tikviewer.org/"
								target="_blank"
								rel="noopener noreferrer"
								className="flex h-6 items-center gap-1.5 whitespace-nowrap rounded-sm border border-slate-300 px-2 text-xs font-medium text-slate-700"
							>
								{/* eslint-disable-next-line @next/next/no-img-element */}
								<img
									src="https://tikviewer.org/brand/favicon.svg"
									alt=""
									width="16"
									height="16"
									className="h-4 w-4"
									loading="lazy"
								/>
								TikViewer
							</a>
						</div>
					))}
				</div>
			</div>
		</div>
	);
}
